<div class="mandatory-email-info-card p-4">
  <h3 class="crnt-typography-heading-3 mb-3 fw-bold">{{ title() }}</h3>
  <p class="crnt-typography-body-functional mb-4">{{ description() }}</p>
  <crnt-button
    (click)="onButtonClick()"
    (keydown.enter)="onButtonClick()"
    class="mt-3"
    variant="secondary"
  >
    {{ buttonText() }}
    <crnt-icon slot="trailing" icon="chevron-right"></crnt-icon>
  </crnt-button>
</div>
